export default "__VITE_ASSET__CUQppFs2__"